
<template lang="html">
  <!-- <Modal
    :title="pageTitle"
    :type="'tray'"
    :withCloseButton="true"
    :applyWarningColors="applyWarningColors"
    @close="close"
  > -->
  <div class="scroll-smooth overflow-y-auto bgcolor m-auto flex-col flex-wrap justify-around px-8 w-screen h-screen">
   <div class="mt-4">
    <a
      href="/"
      tabIndex="1"    
      class="cursor-pointer back-button bg-black py-2 px-4 rounded inline-flex items-center bg-black font-sans font-bold w-32 pt-2 pb-2 tracking-wider hover:text-yellow-300 hover:font-bold border-4 rounded-md text-lg"
    >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
         <span>BACK</span>
    </a>
    </div>
    <div>
      <h1 class="h1">About Big Timer</h1>
      <p>Facilitating a workshop and having the group stick to the program is not always easy. So here's Big Timer to help you end the session in time!</p>
      <h2 class="h2">Support Big Timer</h2>
      <p>Do you like Big Timer? Please tell your coworkers and friends, so they can enjoy it too.</p>
      <p>
        <a href="http://twitter.com/home?status=Big+Timer+is+…+%20+%40kslstn+%23bigtimer" target="_blank" rel="nofollow" class="link">Tweet</a> /
        <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A//www.bigtimer.net"target="_blank" rel="nofollow" class="link">Share on Facebook</a> /
        <a href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.bigtimer.net&title=Big%20Timer&summary=I've%20been%20using%20this%20big%20countdown%20timer%20for%20workshops%20and%20I%20like%20it!&source="target="_blank" rel="nofollow" class="link">Share on LinkedIn</a>
      </p>
    </div>

  
    <VueAccordion>
      <VueAccordionItem
        title="Keyboard shortcuts"
        :initOpen="false"
        :reducedMotion="settingReducedMotion"
      >
        <p>You can <span class="touch">tap</span><span class="no-touch">click</span> and hold the on-screen + and – buttons to quickly adjust the duration of the timer. Use the keyboard for the following:</p>
        <NotificationContentKeyboard />
      </VueAccordionItem>
      <VueAccordionItem
        title="URL tricks"
        :initOpen="false"
        :reducedMotion="settingReducedMotion"
      >
        <p>The URL in your browser's address bar contains the duration of the timer. This means you can:</p>
        <ul>
          <li>Bookmark Big Timer with multiple times with different durations</li>
          <li>Link from a presentation to Big Timer with the duration you need for that item</li>
        </ul>
        <p>If you pause the timer and add <code>&amp;go=true</code> to the URL, Big Timer will start running immediately when you open that URL next time.<p>
        <p>If you send the URL of a running timer to another computer, both computers will count down to exactly the same time.</p>
      </VueAccordionItem>
      <!-- <VueAccordionItem
        title="Who made this?"
        :initOpen="false"
        :reducedMotion="settingReducedMotion"
      >
        <p>Big Timer was designed and built by Koos Looijesteijn. Tom Winters now maintains the project.</p>
      </VueAccordionItem>
      <VueAccordionItem
        title="What’s new?"
        :initOpen="false"
        :reducedMotion="settingReducedMotion"
      >
        <div class="all-release-notes" v-for="release in releaseNotes">
          <p class="h4">{{release.date}}</p>
          <h3 class="h3">{{release.title}}</h3>
          <p v-html="release.body"/>
        </div>
      </VueAccordionItem> -->
      <VueAccordionItem
        title="Your privacy"
        :initOpen="false"
        :reducedMotion="settingReducedMotion"
      >
      <div class="m-auto p-auto container scroll-smooth overflow-y-auto flex flex-col h-96">

<p>This Site is affiliated with CMI Marketing, Inc., d/b/a CafeMedia ("CafeMedia") for the purposes of placing advertising on the Site, and CafeMedia will collect and use certain data for advertising purposes. To learn more about CafeMedia's data usage, click here: <a href="https://www.cafemedia.com/publisher-advertising-privacy-policy" target="_blank">www.cafemedia.com/publisher-advertising-privacy-policy</a> </p>

        <p>At BigTimer, accessible from https://www.bigtimer.net/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by BigTimer and how we use it.</p>

<p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>

<p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in BigTimer. This policy is not applicable to any information collected offline or via channels other than this website. </p>
<br/>
<h2 class="font-semibold text-3xl">Consent</h2>

<p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>
<br/>
<h2 class="font-semibold text-3xl">Information we collect</h2>

<p>The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.</p>
<p>If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.</p>
<p>When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.</p>
<br/>
<h2 class="font-semibold text-3xl">How we use your information</h2>

<p>We use the information we collect in various ways, including to:</p>

<ul>
<li>Provide, operate, and maintain our website</li>
<li>Improve, personalize, and expand our website</li>
<li>Understand and analyze how you use our website</li>
<li>Develop new products, services, features, and functionality</li>
<li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
<li>Send you emails</li>
<li>Find and prevent fraud</li>
</ul>
<br/>
<h2 class="font-semibold text-3xl">Log Files</h2>

<p>BigTimer follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP)
 addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.</p>
<br/>
<h2 class="font-semibold text-3xl">Cookies and Web Beacons</h2>
<p>Like any other website, BigTimer uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.</p>

<p>For more general information on cookies, please read <a href="https://www.cookieconsent.com/">more on the Cookie Consent website</a>.</p>
<br/>
<h2 class="font-semibold text-3xl">Google DoubleClick DART Cookie</h2>

<p>Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.website.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL – <a href="https://policies.google.com/technologies/ads">https://policies.google.com/technologies/ads</a></p>
<br/>
<h2 class="font-semibold text-3xl">Our Advertising Partners</h2>

<p>Some of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below.</p>
<ul>
    <li>
        <p>Google</p>
        <p><a href="https://policies.google.com/technologies/ads">https://policies.google.com/technologies/ads</a></p>
    </li>
</ul>
<br/>
<h2 class="font-semibold text-3xl">Advertising Partners Privacy Policies</h2>

<P>You may consult this list to find the Privacy Policy for each of the advertising partners of BigTimer.</p>

<p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on BigTimer, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>

<p>Note that BigTimer has no access to or control over these cookies that are used by third-party advertisers.</p>
<br/>
<h2 class="font-semibold text-3xl">Third Party Privacy Policies</h2>

<p>BigTimer's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. </p>

<p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.</p>
<br/>
<h2 class="font-semibold text-3xl">CCPA Privacy Rights (Do Not Sell My Personal Information)</h2>

<p>Under the CCPA, among other rights, California consumers have the right to:</p>
<p>Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.</p>
<p>Request that a business delete any personal data about the consumer that a business has collected.</p>
<p>Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</p>
<p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>
<br/>
<h2 class="font-semibold text-3xl">GDPR Data Protection Rights</h2>

<p>We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>
<p>The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.</p>
<p>The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</p>
<p>The right to erasure – You have the right to request that we erase your personal data, under certain conditions.</p>
<p>The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.</p>
<p>The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.</p>
<p>The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</p>
<p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>
<br/>
<h2 class="font-semibold text-3xl">Children's Information</h2>

<p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>

<p>BigTimer does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>


        <!-- <h3 class="h3" id="informationcollected">Information collected</h3>
        <p>Every visit to this website as well as some of the things users do with the application (like clicking on buttons) and some of the things done by the application (like showing that the timer has ended) are tracked. Those data are anonymized.</p>
        <p>I’m collecting that information to have the opportunity to assess how I can improve the application. </p>
        <p>The application saves your preferences to your browser’s local storage. Parts of the state of the application is stored there, such as whether or not the timer is running and when it should end. That enables you to close the browser tab, return and continue just how you left it. That information is only stored on your computer.</p>
        <h3 class="h3" id="cookies">Cookies</h3>
        <p>Cookies are placed to recognize return visitors. They are not used to track individuals. That way I can assess how common it is for users to frequently use the application and adjust the design to that. If you don’t want to have your visits tracked, you can opt out of it.</p>
        <h3 class="h3" id="datastorage">Data storage</h3>
        <p>To collect use data, I use Google analytics software of which I’m running my own instance. Only I have access to those data and will not share the data with others.</p> -->
        <!-- <h3 class="h3" id="dataretention">Data retention</h3>
        <p>All personal use logs are removed after 6 months. Only aggregate data remains in the database. </p>
        <h3 class="h3" id="optout">Opt out</h3>
        <p v-if="!optedOut">If you don't like your use being tracked for product improvement, you can <a href="" class="link" @click="optOut" rel="nofollow">stop the tracking</a>.</p>
        <div v-if="optedOut" class="opted-out">
          <p>Alright! Your use is no longer being tracked.</p>
          <p><a href="" rel="nofollow" class="link" @click="optIn">Undo</a></p>
        </div> -->
        </div>
      </VueAccordionItem>
      <VueAccordionItem
        title="Copyright &amp; attributions"
        :initOpen="false"
        :reducedMotion="settingReducedMotion"
        >
        <div class="container scroll-smooth overflow-y-auto flex flex-col h-screen">
        <p>The large numbers for the countdown itself are made with a customized font based on letter shapes from <a href="https://www.latofonts.com/" target="_blank" rel="nofollow" class="link">Lato</a>. You can get and edit the <a href="https://github.com/kslstn/big-timer-font" target="_blank" rel="nofollow" class="link">Big Timer font</a> under the <a href="https://scripts.sil.org/cms/scripts/page.php?item_id=OFL_web" target="_blank" rel="nofollow" class="link">SIL Open Font License</a>.</p>
        <p>The typeface used for the other text is <a href="http://indestructibletype.com/Jost.html" target="_blank" rel="nofollow" class="link">Jost</a>.</p>
        <p>Big Timer is built with <a href="https://vuejs.org/" target="_blank" rel="nofollow" class="link">Vue</a> using the libraries <a href="https://github.com/mirari/vue-fullscreen" target="_blank" rel="nofollow" class="link">Vue Fullscreen</a> and <a href="http://animejs.com/" target="_blank" rel="nofollow" class="link">Anime JS</a>.</p>
        <!-- <p>Everything else © 2017–2021 Koos Looijesteijn, all rights reserved.</p> -->
      </div>
      </VueAccordionItem>
    </VueAccordion>
    <!-- <div class="cta-feedback-wrapper">
      <a
        href="mailto:info@bigtimer.net"
        v-if="!showContactInfo"
        @click="createMail"
        class="button primary-dark with-label">
        <span>Send feedback</span>
      </a>
      <p v-if="showContactInfo">
        Please mail me at {{mailAddress}}</span>.
      </p>
    </div> -->
  </div>
</template>

<script>
// Data
import ReleaseNotesJSON from "../assets/data/ReleaseNotes";

// Components
import Modal from "./Modal";
import VueAccordionItem from "./VueAccordionItem";
import VueAccordion from "./VueAccordion";
import NotificationContentKeyboard from "./NotificationContentKeyboard";

export default {
  name: "Info",

  components: {
    ReleaseNotesJSON,
    Modal,
    VueAccordionItem,
    VueAccordion,
    NotificationContentKeyboard,
  },

  props: {
    settingReducedMotion: {
      required: true,
    },
    applyWarningColors: {
      required: true,
      type: Boolean,
    },
  },

  data() {
    return {
      releaseNotes: ReleaseNotesJSON,
      pageTitle: "About Big Timer",
      optedOut: false,
      showContactInfo: false,
      mailAddress: "",
    };
  },

  head: {
    title: function () {
      return {
        inner: "About",
      };
    },
    link: function () {
      return [
        {
          rel: "canonical",
          href: "https://www.bigtimer.net" + this.$route.path,
          id: "canonical",
        },
      ];
    },
  },

  mounted() {
    // this.$emit("update:visibleTray", this.componentName);
  },

  beforeDestroy() {
    this.$emit("update:visibleTray", "");
  },

  methods: {
    createMail(e) {
      e.preventDefault();
      const z = "mailto:";
      const a = "support@";
      const b = "bigtimer.net";
      const c = "?subject=Here's%20what%20I%20think%20of%20Big%20Timer";
      const address = z + a + b + c;

      let t = setTimeout(() => {
        // Show email address when it looks like the email client isn't opened.
        this.mailAddress = a + b;
        this.showContactInfo = true;
      }, 200);
      window.addEventListener("blur", () => {
        clearTimeout(t);
      });
      location.href = address;
    },

    optOut(e) {
      e.preventDefault();
      _paq.push(["forgetConsentGiven"]);
      this.optedOut = true;
    },

    optIn() {
      _paq.push(["rememberConsentGiven"]);
      this.optedOut = false;
    },

    close() {
      this.$router.push({ name: "home" });
    },
  },

  computed: {
    componentName() {
      if (!this.$vnode) {
        return "[unknown]";
      } else if (this.$vnode.tag) {
        let name = this.$vnode.tag;
        return name.replace(/vue-component-\d+-/i, "");
      } else if (vm.$el.id) {
        return vm.$el.id;
      }
    },

    isIOS() {
      const iDevices = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ];
      if (navigator.platform) {
        while (iDevices.length) {
          if (navigator.platform === iDevices.pop()) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../style/abstracts/variables.scss";
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";

.bgcolor {
  background: #fc0;
}

.back-button {
  color: #fc0;
  border-color: #000;
  border-block-color: #000;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
}

.no-touch {
  display: none;
}
.no-touch-events {
  .touch {
    display: none;
  }
  .no-touch {
    display: inline;
  }
}

.opted-out {
  margin-bottom: $large + rem;
}
.cta-feedback-wrapper {
  padding-bottom: $large + rem;
  text-align: center;
}
.all-release-notes {
  .h3 {
    margin-top: 0;
  }

  .date {
    margin-top: $default + rem;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Info.vue